import React from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {API_AUTH_LOGIN_SUCCESS, API_AUTH_LOGIN_FAILURE} from 'common/types';
import {push} from 'react-router-redux';
import {Button, Form, Header, Input, Message, Segment, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import {LOGIN} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {AUTH_HANDLE_PROFILE} from 'common/types';
export class PWLogin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      updateMessage: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    document.title = LOGIN;
  }

  unsuccessfulLoginAttemptErrorMsg =
    'Login attempt was unsuccessful. If this account exists, you have two attempts before the account will be temporarily locked.';
  userAccountLockedErrorMsg =
    'Login attempt was unsuccessful. If this account exists, you have been temporarily locked out of the system.';
  twoAttemptsRemainingErrorMsg =
    'Login attempt was unsuccessful. If this account exists, you have two attempts before the account will be temporarily locked.';
  oneAttemptRemainingErrorMsg =
    'Login attempt was unsuccessful. If this account exists, you have one attempt before the account will be temporarily locked.';

  handleChange(e) {
    const {name, value} = e.target;
    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();
    const {username, password} = this.state;
    if (username && password) {
      let response = this.props.loginAttempt(username, password);
      response.then((res) => {
        this.handleResponseFromServer(res);
      });
    }
  }

  setMsg = (msg) => {
    this.setState({
      username: '',
      password: '',
      updateMessage: msg,
    });
  };

  handleResponseFromServer = (res) => {
    if (res !== undefined && res.type === API_AUTH_LOGIN_SUCCESS) {
      this.props.loadUserProfile(this.state.username);
      this.props.loginSuccess();
    } else if (res !== undefined && res.type === API_AUTH_LOGIN_FAILURE) {
      let msg = this.unsuccessfulLoginAttemptErrorMsg;
      if (res.payload.response) {
        res.payload.response.then((response) => {
          this.handleUnsuccessfulLoginResponse(response, msg);
        });
      } else {
        this.setMsg(msg);
      }
    }
  };

  handleUnsuccessfulLoginResponse = (response, msg) => {
    var error = response.errorMessage;
    const redirectUrl = response.redirectUrl;
    this.focusUsername();
    if (error === 'unsuccessfulLoginAttempt') {
      var attemptsRemaining = response.attemptsRemaining;
      if (attemptsRemaining !== null && attemptsRemaining !== undefined) {
        if (attemptsRemaining === 2) {
          msg = this.twoAttemptsRemainingErrorMsg;
        } else if (attemptsRemaining === 1) {
          msg = this.oneAttemptRemainingErrorMsg;
        } else if (attemptsRemaining === 0) {
          msg = this.userAccountLockedErrorMsg;
        }
      } else {
        msg = this.unsuccessfulLoginAttemptErrorMsg;
      }
    } else if (error === 'userAccountLocked') {
      msg = this.userAccountLockedErrorMsg;
    } else if (redirectUrl) {
      msg = 'Redirecting to mock Login.gov...';
      window.location.href = redirectUrl;
    }
    this.setMsg(msg);
  };

  focusUsername = () => {
    this.usernameInput.focus();
  };

  render() {
    return (
      <Segment>
        <Header as="h3" dividing color="blue">
          Log in
        </Header>
        <Message hidden={!(this.state.updateMessage !== '')} negative>
          {this.state.updateMessage}
        </Message>
        <Form onSubmit={this.handleSubmit}>
          <Form.Field>
            <label htmlFor="username">Email</label>
            <Input
              ref={(input) => {
                this.usernameInput = input;
              }}
              id="username"
              name="username"
              title="Required: E-mail"
              value={this.state.username}
              onChange={this.handleChange}
              fluid
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="password">Password</label>
            <Form.Input
              id="password"
              name="password"
              title="Required: Password"
              value={this.state.password}
              onChange={this.handleChange}
              fluid
              type="password"
            />
            <div style={{textAlign: 'right'}}>
              <Link to="/requestPasswordReset">Forgot password?</Link>
            </div>
          </Form.Field>
          <Form.Field>
            <Button primary>Log in</Button>
          </Form.Field>
          <Form.Field>
            <Button basic primary as={Link} to="/register">
              Create an account
            </Button>
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

const redirectURL = new URLSearchParams(location.search).get('redirect');

export const mapDispatchToProps = (dispatch) => {
  return {
    loginAttempt: (username, password) => {
      const action = ApiActions.auth.login(username.toLowerCase(), password);
      const response = dispatch(action);
      return response;
    },
    loadUserProfile: async (username) => {
      const action = ApiActions.profile.getUser(username.toLowerCase());
      const profile = await dispatch(action);
      dispatch({type: AUTH_HANDLE_PROFILE, payload: profile.payload});
    },
    loginSuccess: () => {
      if (redirectURL == null) {
        dispatch(push('/'));
      } else {
        dispatch(push(redirectURL));
      }
    },
  };
};

export const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(PWLogin);
